import { render } from "./exposure-detail.vue?vue&type=template&id=808444c8&ts=true"
import script from "./exposure-detail.ts?vue&type=script&lang=ts&external"
export * from "./exposure-detail.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__